"use client"

import {
  Badge,
  Divider,
  LogoutButton,
  NavigationItem,
} from "@/components/atoms"
import { Dropdown } from "@/components/molecules"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"
import { ProfileIcon } from "@/icons"
import { HttpTypes } from "@medusajs/types"
import { useState } from "react"
import { useTranslate } from "@tolgee/react"
import { useChat} from "@/context/ChatContext";

export const UserDropdown = ({
  user,
}: {
  user: HttpTypes.StoreCustomer | null
}) => {
  const [open, setOpen] = useState(false)
  const {unreadMessageCount:unreads} = useChat()
  const { t } = useTranslate()

  return (
    <div
      className="relative"
      onMouseOver={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
    >
      <LocalizedClientLink href="/user" className="relative">
        <ProfileIcon size={20} />
      </LocalizedClientLink>

      <div className="hidden md:block">
        <Dropdown show={open}>
          {user ? (
            <div className="p-1">
              <div className="lg:w-[200px]">
                <h3 className="uppercase heading-xs border-b p-4">
                  {t("user_dropdown.account_heading")}
                </h3>
              </div>

              <NavigationItem href="/user/orders">
                {t("user_dropdown.orders")}
              </NavigationItem>

              <NavigationItem href="/user/messages" className="relative">
                {t("user_dropdown.messages")}
                {Boolean(unreads) && (
                  <Badge className="absolute top-3 left-24 w-4 h-4 p-0">
                    {unreads}
                  </Badge>
                )}
              </NavigationItem>

              <NavigationItem href="/user/returns">
                {t("user_dropdown.returns")}
              </NavigationItem>

              <NavigationItem href="/user/addresses">
                {t("user_dropdown.addresses")}
              </NavigationItem>

              <NavigationItem href="/user/reviews">
                {t("user_dropdown.reviews")}
              </NavigationItem>

              <NavigationItem href="/user/wishlist">
                {t("user_dropdown.wishlist")}
              </NavigationItem>

              <NavigationItem href="/user/affiliatex">
                {t("user_dropdown.affiliatex")}
              </NavigationItem>

              <Divider />

              <NavigationItem href="/user/settings">
                {t("user_dropdown.settings")}
              </NavigationItem>

              <LogoutButton />
            </div>
          ) : (
            <div className="p-1">
              <NavigationItem href="/user">
                {t("user_dropdown.login")}
              </NavigationItem>
              <NavigationItem href="/user/register">
                {t("user_dropdown.register")}
              </NavigationItem>
            </div>
          )}
        </Dropdown>
      </div>

    </div>
  )
}
